import { createContext } from 'react';

/**
 * Panel Layout Context
 * Provides sidebar state and dispatch function to child components
 */
export const PanelLayoutContext = createContext();

export const PanelLayoutProvider = PanelLayoutContext.Provider;
export const PanelLayoutConsumer = PanelLayoutContext.Consumer;

// Backward compatibility exports
export const DashboardContext = PanelLayoutContext;
export const DashboardProvider = PanelLayoutProvider;
export const DashboardConsumer = PanelLayoutConsumer;

